import React from 'react';
import cx from 'classnames';
import { Icon } from '../../../components/Icons';
import { Setting } from './';
import styles from './style.module.css';
import { SubMenu } from './SubMenu';

interface Props {
  setting: Setting;
  isActive?: boolean;
}
export const MenuItem = ({ isActive = false, setting }: Props) => {
  const { action, icon, text, subMenuItems } = setting;
  const itemClass = cx(
    'b--transparent ba bw2 border-box bt-0 br-0 bb-0 pointer flex items-center',
    styles.itemsClass,
    {
      [styles.active]: isActive,
      red: isActive,
      abbey: !isActive,
      [styles.ordersSvg]: icon === 'SvgIconOrders',
      [styles.salesSvg]: icon === 'SvgIconMySales',
    },
  );
  const subMenu = isActive && subMenuItems && subMenuItems.length > 0 && (
    <SubMenu
      items={subMenuItems}
      parentAriaLabel={text}
      selectedItem={setting.selectedSubMenuItem}
    />
  );
  return (
    <li className="list">
      <div className={itemClass} onClick={action}>
        <Icon className="ml12 mr8" name={icon} height={24} width={24} />
        <p className="ma0">{text}</p>
      </div>
      {subMenu}
    </li>
  );
};
